/**
 * Returns the first block found that recursively matches one of the given blockTypes,
 * starting from a single given block.
 * @param {object} block - WordPress block object
 * @param {string[]} blockTypes - array of block keys
 * @returns {object} - the first found block that matches one of the requested blockTypes
 */
export default function getBlockOfTypeRecursively(block, blockTypes) {
    // check all target blockTypes, and if we’ve found a match there’s no need to recurse through innerBlocks
    if (blockTypes.some(blockType => block.blockName === blockType)) {
        return block;
    }

    if (block.innerBlocks?.length > 0) {
        for (let i = 0; i < block.innerBlocks.length; i++) {
            const matchedBlock = getBlockOfTypeRecursively(block.innerBlocks[i], blockTypes);

            if (matchedBlock) {
                return matchedBlock;
            }
        }
    }
}
